import React from 'react'
import { NavLink, useLocation } from 'react-router-dom'
import './style.scss'
import { IsPathActive } from '../../utils/helpers'

const Matches = () => {
    const { pathname } = useLocation()
    const linkClass = ({ isActive }) => isActive ? 'btn shadow-sm isActive' : 'btn shadow-sm'
    const rootActive = IsPathActive(pathname, '/matches/')

    return (
        <div className="custom-navbar">
        <div className="container">
            <div className="row">
                <div className="col-12 text-center">
                    <NavLink
                        className={`btn shadow-sm ${rootActive ? 'isActive' : ''}`}
                        to="/matches/"
                    >new matches</NavLink>
                    <NavLink
                        className={linkClass}
                        to="/matches/today"
                    >today matches</NavLink>
                    <NavLink
                        className={linkClass}
                        to="/matches/all"
                    >all matches</NavLink>
                    <NavLink
                        className={linkClass}
                        to="/matches/near-me"
                    >near me</NavLink>
                    <NavLink
                        className={linkClass}
                        to="/matches/recently-viewed"
                    >recently viewed</NavLink>
                </div>
            </div>
        </div>
    </div>
    );
};

export default Matches;
